import { render, staticRenderFns } from "./MappModel.vue?vue&type=template&id=224d1dab&scoped=true"
import script from "./MappModel.vue?vue&type=script&lang=js"
export * from "./MappModel.vue?vue&type=script&lang=js"
import style0 from "./MappModel.vue?vue&type=style&index=0&id=224d1dab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d1dab",
  null
  
)

export default component.exports